
import Vue, { PropType } from 'vue';

const ALIGNMENTS = ['start', 'center', 'end', 'space', 'spread'] as const;
const VERTICAL_ALIGNMENTS = ['start', 'center', 'end', 'stretch'] as const;

type Align = typeof ALIGNMENTS[number];
type VerticalAlign = typeof VERTICAL_ALIGNMENTS[number];

export default Vue.extend({
  provide() {
    return {
      of: this.of,
    };
  },
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    of: {
      type: [String, Number],
      default: '12',
    },
    gutters: {
      type: Boolean,
      default: true,
    },
    gutterSize: {
      type: String,
      validator(val: string) {
        return [
          'xxx-small',
          'xx-small',
          'x-small',
          'small',
          'medium',
          'large',
          'x-large',
          'xx-large',
        ].includes(val);
      },
      default: undefined,
    },
    align: {
      type: String as PropType<Align>,
      default: undefined,
      validator: (val) => ALIGNMENTS.includes(val),
    },
    verticalAlign: {
      type: String as PropType<VerticalAlign>,
      default: undefined,
      validator: (val) => VERTICAL_ALIGNMENTS.includes(val),
    },
    vertical: {
      type: Boolean,
      default: false,
    },
  },
  render(h) {
    return h(
      this.tag,
      {
        staticClass: 'slds-grid',
        class: [
          {
            [this.gutterSize
              ? `slds-gutters_${this.gutterSize}`
              : 'slds-gutters']: this.gutters,
            [`slds-grid_vertical-align-${this.verticalAlign}`]:
              this.verticalAlign !== undefined &&
              this.verticalAlign !== 'stretch',
            'slds-grid_vertical-stretch': this.verticalAlign === 'stretch',
            [`slds-grid_align-${this.align}`]: this.align,
            'slds-grid_vertical': this.vertical,
          },
        ],
      },
      this.$slots.default
    );
  },
});
